import { METHOD } from "../../data/content";
import { SectionHeading } from "../common";
import { Reveal } from "../Reveal";

export const Method = () => (
    <section className="py-24 md:py-32 border-b border-thg-border" data-testid="method-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index="01"
                overline="The Method"
                title="One operating method, applied to everything we build."
            />
            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-thg-border">
                {METHOD.map((m, i) => (
                    <Reveal
                        key={m.step}
                        delay={i * 0.1}
                        className="border-b border-r border-thg-border p-8 md:p-10 hover:bg-thg-surface transition-colors duration-300"
                    >
                        <span className="text-xs tracking-[0.2em] font-bold text-thg-red">{m.step}</span>
                        <h3 className="mt-4 font-display text-xl md:text-2xl font-medium text-white uppercase tracking-wide">
                            {m.name}
                        </h3>
                        <p className="mt-4 text-sm leading-relaxed text-thg-secondary">{m.text}</p>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
